import React from 'react'
import styled from 'styled-components'


const WrapperCompanyInfo=styled.div`
    background: #2196f3;
`; 

const CompanyName = styled.h3`
    margin: 0 0 1rem 0;
    text-align: center;
    color: #fff; 
    @media (min-width: 700px) {
        text-align: left; 
    }
`;

const WrapperList = styled.ul`
    list-style: none;
    margin:0 0 1rem 0;
    padding:0;
    color: #FFF;
    text-align: center;
    @media (min-width: 700px) {
        text-align: left; 
    }
`;


const CompanyInfo = () => (
    <WrapperCompanyInfo>
        <CompanyName>Realtime Digital Solutions</CompanyName>
        <WrapperList>
            <li>Address: P.O.BOX 74377 00100 NAIROBI</li>
            <li>Offices: Ngong Hills Plaza, Suite 314</li>
            <li>Phone Number: 0715 532 259</li>
            <li>Email: info@getairtime.co.ke</li>
        </WrapperList>
    </WrapperCompanyInfo>
)

export default CompanyInfo